<!--<template>-->
<!--  <div v-if="message" class="messages" :class="[status ? status : '']">-->
<!--    {{ $t(`messages.${message}`) }}-->
<!--    -->
<!--  </div>-->
<!--</template>-->

<!--<script setup lang="ts">-->
<!--import { computed } from 'vue';-->
<!--import { useMessageStore } from '@/store/message.store';-->
<!--const messageStore = useMessageStore();-->
<!--const message = computed(() => messageStore.getMessage);-->
<!--const status = computed(() => {-->
<!--  return `messages&#45;&#45;${messageStore.getStatus}`;-->
<!--});-->
<!--</script>-->
<template>
  <div
    v-if="message"
    class="toast align-items-center show"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    :class="[status]"
  >
    <div class="d-flex">
      <div class="toast-body">
        {{ $t(`messages.${message}`) }}
      </div>
      <button
        type="button"
        class="btn-close me-2 m-auto"
        aria-label="Close"
        @click="clearMessage"
      ></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMessageStore } from '@/store/message.store';

const messageStore = useMessageStore();
const message = computed(() => messageStore.getMessage);
const status = computed(() => `bg-${messageStore.getStatus}`);
const clearMessage = () => {
  messageStore.$reset();
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1050;
}
</style>